import { render, staticRenderFns } from "./qvyuplace-add.vue?vue&type=template&id=01316dc6&scoped=true&"
import script from "./qvyuplace-add.vue?vue&type=script&lang=js&"
export * from "./qvyuplace-add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01316dc6",
  null
  
)

export default component.exports